import { render, staticRenderFns } from "./ReclaimDetail.vue?vue&type=template&id=54b28354"
import script from "./ReclaimDetail.vue?vue&type=script&lang=js"
export * from "./ReclaimDetail.vue?vue&type=script&lang=js"
import style0 from "./ReclaimDetail.vue?vue&type=style&index=0&id=54b28354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports